import { useMutation } from '@tanstack/react-query';

import { CustomNotification } from 'common/components';

import * as reportingServices from 'services/reporting';

import { sendDownload } from 'config/axios';

export const useBillingReportActions = () => {
  return useMutation({
    mutationFn: reportingServices.exportAWGBillingReport,
    onSuccess: (response) => {
      if (response?.isSuccess) {
        if (response?.data?.downloadUrl) {
          sendDownload({
            url: response?.data?.downloadUrl,
          });
          CustomNotification.success('Downloaded successfully');
        } else {
          CustomNotification.error('Cannot download the file');
        }
      } else {
        CustomNotification.error(response?.message ?? 'Something went wrong');
      }
    },
    onError: () => {
      CustomNotification.error('Server Error');
    },
  });
};
